<template>
  <v-app>
     <!-- =====================================================
         BLOQUEO GLOBAL MIENTRAS TRABAJA EL DEMONIO
         ===================================================== -->
    <v-overlay
      :value="store.systemBlocked || systemReloading"
      :opacity="1"
      color="#f4faf8"
      z-index="999999"
      class="system-processing-overlay"
    >
      <div class="system-processing-content">
        <div class="system-processing-logos">
          <v-img
            :src="require('@/assets/logo_electroliga.svg')"
            alt="Electroliga"
            contain
            max-width="290"
            class="system-electroliga-logo"
          />

          <v-img
            :src="require('@/assets/SIMULART_COLOR.svg')"
            alt="Simulart"
            contain
            max-width="130"
            class="system-simulart-logo"
          />
        </div>

        <v-progress-circular
          indeterminate
          :size="72"
          :width="6"
          color="#58A39E"
          class="system-processing-spinner"
        />

        <template v-if="systemReloading">
          <div class="system-processing-title">
            Procesos completados
          </div>

          <div class="system-processing-message">
            Actualizando los datos del juego...
          </div>
        </template>

        <template v-else>
          <div class="system-processing-title">
            {{
              store.systemMessage
              || "Calculando ganancias y resolviendo el mercado..."
            }}
          </div>

          <div class="system-processing-message">
            Vuelve en unos minutos
          </div>
        </template>

        <div
          v-if="store.systemProcess && !systemReloading"
          class="system-processing-process"
        >
          {{ textoProcesoSistema }}
        </div>
      </div>
    </v-overlay>
    <v-main class="game-main">
      <v-container class="home-container">
        <v-card class="home-header-card pa-4 mb-4" rounded="xl">

        <div class="home-header">
            <div class="home-header-left">
              <div class="logos-column mr-4">
                <v-img
                  :src="require('@/assets/logo_electroliga.svg')"
                  alt="electroliga logo"
                  contain
                  class="electroliga-logo"
                />

                <v-img
                  :src="require('@/assets/SIMULART_COLOR.svg')"
                  alt="simulart logo"
                  contain
                  class="simulart-logo-under"
                />
              </div>

              <div class="home-title-wrapper">
                <div class="orbitron-title">
                  {{ store.currentAreaName }}
                </div>
              </div>
            </div>

            <div class="home-header-right">
              <v-menu offset-y>
  <template v-slot:activator="{ on, attrs }">
    <button
      class="avatar-button mr-2"
      v-bind="attrs"
      v-on="on"
      type="button"
      title="Elegir avatar"
    >
      <v-avatar size="42" class="user-avatar-selector">
        <v-img
          v-if="selectedAvatar"
          :src="selectedAvatar"
          alt="avatar usuario"
          cover
        />

        <span v-else class="material-symbols-outlined filled user-icon">
          account_circle
        </span>
      </v-avatar>
    </button>
  </template>

  <v-card class="avatar-menu-card pa-3" rounded="lg">
    <div class="avatar-menu-title mb-3">
      Elige tu avatar
    </div>

    <div class="avatar-grid">
      <button
        v-for="avatar in avatarOptions"
        :key="avatar.id"
        type="button"
        class="avatar-option"
        :class="{ 'avatar-option-active': selectedAvatarId === avatar.id }"
        @click="selectAvatar(avatar)"
      >
        <img
          :src="avatar.src"
          :alt="avatar.name"
          class="avatar-option-img"
        />
      </button>
    </div>
  </v-card>
</v-menu>

              <v-chip class="user-chip mr-2" color="white" text-color="black" small>
                {{ store.authUser?.username || "Jugador" }}
              </v-chip>

              <div class="header-action-icons">
                <button
                  type="button"
                  class="header-icon-btn"
                  title="Mandar incidencia"
                  aria-label="Mandar incidencia"
                  @click="sendIncidence"
                >
                  <span class="material-symbols-outlined">
                    mail
                  </span>
                </button>

                <button
                  type="button"
                  class="header-icon-btn delete-account-icon-btn"
                  title="Eliminar cuenta"
                  aria-label="Eliminar cuenta"
                  @click="confirmDeleteAccount"
                >
                  <span class="material-symbols-outlined">
                    delete
                  </span>
                </button>
              </div>

              <v-btn
                class="logout-btn"
                small
                outlined
                color="secondary"
                @click="logout"
              >
                Salir
              </v-btn>
            </div>
          </div>
        </v-card>

        <!-- Intro visual de nueva temporada -->
        <v-dialog
          v-model="mostrarIntroTemporada"
          :fullscreen="$vuetify.breakpoint.smAndDown"
          persistent
          max-width="520"
          content-class="intro-temporada-dialog"
        >
          <v-card class="intro-temporada-card" rounded="xl">
            <div class="intro-temporada-body">
              <transition name="intro-fade" mode="out-in">
                <img
                  v-if="introSlideActual"
                  :key="introFrameActual"
                  :src="introSlideActual.src"
                  :alt="introSlideActual.title"
                  class="intro-temporada-image"
                />
              </transition>
            </div>

            <div class="intro-temporada-footer">
              <div class="intro-progress" aria-label="Progreso de la introducción">
                <span
                  v-for="(slide, index) in introSlides"
                  :key="slide.id"
                  class="intro-dot"
                  :class="{ 'intro-dot-active': index === introFrameActual }"
                />
              </div>

              <div class="intro-actions">
              <v-btn
                text
                class="intro-skip-btn"
                @click="cerrarIntroTemporada"
              >
                Saltar
              </v-btn>

              <div class="intro-navigation">
                <v-btn
                  v-if="introFrameActual > 0"
                  text
                  class="intro-back-btn"
                  @click="anteriorIntroSlide"
                >
                  <span class="material-symbols-outlined intro-btn-icon">
                    arrow_back
                  </span>

                  Anterior
                </v-btn>

                <v-btn
                  class="intro-next-btn"
                  rounded
                  elevation="0"
                  @click="siguienteIntroSlide"
                >
                  {{
                    introFrameActual === introSlides.length - 1
                      ? "Entrar"
                      : "Siguiente"
                  }}

                  <span
                    v-if="introFrameActual < introSlides.length - 1"
                    class="material-symbols-outlined intro-btn-icon intro-btn-icon-right"
                  >
                    arrow_forward
                  </span>
                </v-btn>
              </div>
            </div>
            </div>
          </v-card>
        </v-dialog>

        <v-btn
          v-if="
            modoPruebaIntro
            && esLigaIntroPermitida
            && !mostrarIntroTemporada
          "
          class="intro-test-btn"
          rounded
          elevation="4"
          @click="abrirIntroTemporada"
        >
          Probar intro
        </v-btn>

        <transition name="page-enter" mode="out-in">
          <router-view />
        </transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { useGameStore } from "@/stores/game";
import axios from "@/axios";
import Swal from "sweetalert2";

export default {
  name: "PaginaHome",

  data() {
    return {
      store: useGameStore(),
      // Control global del demonio
      systemStatusInterval: null,
      systemWasBlocked: false,
      systemReloading: false,
      systemStatusReady: false,

      selectedAvatarId: null,
      selectedAvatar: null,

   
      modoPruebaIntro: false,
      ligaIntroPermitidaId: 1,

      mostrarIntroTemporada: false,
      introFrameActual: 0,
      introTimer: null,
      ligaIntroActual: null,
      ligasIntroComprobadas: [],
      introRequestVersion: 0,

      introSlides: [
        {
          id: 1,
          title: "Bienvenido a la nueva temporada",
          src: require("@/assets/intro-temporada/1.png"),
          duration: 3000,
        },
        {
          id: 2,
          title: "Vuelven los jugadores",
          src: require("@/assets/intro-temporada/2.png"),
          duration: 5500,
        },
        {
          id: 3,
          title: "Continúan los jugadores",
          src: require("@/assets/intro-temporada/3.png"),
          duration: 5500,
        },
        {
          id: 4,
          title: "Competitividad real",
          src: require("@/assets/intro-temporada/4.png"),
          duration: 5500,
        },
        {
          id: 5,
          title: "Cero trampas",
          src: require("@/assets/intro-temporada/5.png"),
          duration: 4000,
        },
        {
          id: 6,
          title: "Que empiecen los segundos juegos del hambre",
          src: require("@/assets/intro-temporada/6.png"),
          duration: 4500,
        },
      ],

      avatarOptions: [
        {
          id: 1,
          name: "Solar",
          src: require("@/assets/1.png"),
        },
        {
          id: 2,
          name: "Eólica",
          src: require("@/assets/2.png"),
        },
        {
          id: 3,
          name: "Hidráulica",
          src: require("@/assets/3.png"),
        },
        {
          id: 4,
          name: "Nuclear",
          src: require("@/assets/4.png"),
        },
        {
          id: 5,
          name: "Gas",
          src: require("@/assets/5.png"),
        },
        {
          id: 6,
          name: "Carbón",
          src: require("@/assets/6.png"),
        },
        {
          id: 7,
          name: "Baterías",
          src: require("@/assets/7.png"),
        },
        {
          id: 8,
          name: "Hidrógeno",
          src: require("@/assets/8.png"),
        },
        {
          id: 9,
          name: "Red inteligente",
          src: require("@/assets/9.png"),
        },
        {
          id: 10,
          name: "Biomasa",
          src: require("@/assets/10.png"),
        },
      ],
    };
  },

  computed: {
    
  activeLigaId() {
    const ligaId = Number(
      this.store.currentAreaId
    );

    if (
      Number.isInteger(ligaId) &&
      ligaId > 0
    ) {
      return ligaId;
    }

    return null;
  },

  esLigaIntroPermitida() {
    return (
      Number(this.activeLigaId)
      === Number(this.ligaIntroPermitidaId)
    );
  },

  introSlideActual() {
    return this.introSlides[this.introFrameActual] || null;
  },
  textoProcesoSistema() {
  const proceso = this.store.systemProcess;

  const textos = {
    procesamiento_diario: "Procesando la jornada diaria",
    ganancias: "Calculando ganancias",
    calculando_ganancias: "Calculando ganancias",
    mercado: "Resolviendo el mercado",
    resolviendo_mercado: "Resolviendo el mercado",
    datos: "Actualizando datos",
    actualizando_datos: "Actualizando datos",
  };

  return textos[proceso] || "";
},
},

  watch: {
  activeLigaId: {
    immediate: true,

    handler(ligaId) {
      /*
       * No comprobamos ni consumimos la intro
       * hasta saber que el demonio no está trabajando.
       */
      if (!this.systemStatusReady || this.store.systemBlocked) {
        return;
      }

      const normalizedLigaId = Number(ligaId);

      if (
        !Number.isInteger(normalizedLigaId)
        || normalizedLigaId <= 0
      ) {
        return;
      }

      if (
        normalizedLigaId
        !== Number(this.ligaIntroPermitidaId)
      ) {
        if (
          this.mostrarIntroTemporada
          && !this.modoPruebaIntro
        ) {
          this.cerrarIntroTemporada();
        }

        return;
      }

      if (this.modoPruebaIntro) {
        return;
      }

      this.comprobarIntroTemporada(normalizedLigaId);
    },
  },
},

  async mounted() {
  this.loadSelectedAvatar();

  /*
   * Primero comprobamos si el demonio está trabajando.
   */
  await this.iniciarControlEstadoSistema();

  /*
   * Solo después permitimos comprobar la intro.
   */
  if (
    !this.store.systemBlocked
    && this.activeLigaId
  ) {
    if (
      this.modoPruebaIntro
      && this.esLigaIntroPermitida
    ) {
      this.$nextTick(() => {
        this.abrirIntroTemporada();
      });
    } else {
      await this.comprobarIntroTemporada(
        this.activeLigaId
      );
    }
  }
},

  beforeDestroy() {
  this.limpiarTimerIntro();
  this.detenerControlEstadoSistema();
},

  methods: {
  async confirmDeleteAccount() {
  const result = await Swal.fire({
    icon: "warning",
    title: "¿Eliminar tu cuenta?",
    html: `
      <div style="text-align:left">
        <p>
          Se eliminará definitivamente tu cuenta de
          Electroliga y todos tus datos de juego asociados.
        </p>
        <p>
          <b>Esta acción no se puede deshacer.</b>
        </p>
        <p>
          Escribe <b>ELIMINAR</b> para confirmar.
        </p>
      </div>
    `,
    input: "text",
    inputPlaceholder: "ELIMINAR",
    showCancelButton: true,
    confirmButtonText: "Eliminar cuenta",
    cancelButtonText: "Cancelar",
    buttonsStyling: false,
    customClass: {
      confirmButton: "clausulazo-swal-confirm",
      cancelButton: "clausulazo-swal-cancel",
    },
    preConfirm: (value) => {
      if (String(value || "").trim() !== "ELIMINAR") {
        Swal.showValidationMessage(
          "Debes escribir ELIMINAR para continuar."
        );
        return false;
      }

      return true;
    },
  });

  if (!result.isConfirmed) return;

  try {
    const response = await this.store.deleteAccount();

    if (response?.deleted !== true) {
      throw new Error(
        "El servidor no ha confirmado la eliminación de la cuenta."
      );
    }

    localStorage.removeItem(this.getAvatarStorageKey());

    this.introRequestVersion += 1;
    this.limpiarTimerIntro();
    this.detenerControlEstadoSistema();

    this.store.logout();

    await Swal.fire({
      icon: "success",
      title: "Cuenta eliminada",
      text: "Tu cuenta de Electroliga se ha eliminado correctamente.",
      confirmButtonText: "Entendido",
      buttonsStyling: false,
      customClass: {
        confirmButton: "clausulazo-swal-confirm",
      },
    });

    await this.$router.replace("/login");

  } catch (error) {
    await Swal.fire({
      icon: "error",
      title: "No se pudo eliminar la cuenta",
      text:
        error?.message ||
        "Ha ocurrido un error eliminando la cuenta.",
      confirmButtonText: "Entendido",
      buttonsStyling: false,
      customClass: {
        confirmButton: "clausulazo-swal-confirm",
      },
    });
  }
},
    async iniciarControlEstadoSistema() {
  /*
   * Evitamos crear dos intervalos por accidente.
   */
  this.detenerControlEstadoSistema();

  await this.comprobarEstadoSistema();

  this.systemStatusReady = true;

  /*
    Comprobamos cada 30 segundos.
   
    Esto permite:
    - detectar si alguien entra mientras trabaja el demonio
    - detectar si el demonio empieza mientras el usuario ya está dentro
    - quitar automáticamente la pantalla cuando termina
   */
  this.systemStatusInterval = window.setInterval(() => {
    this.comprobarEstadoSistema();
  }, 30000);
},


detenerControlEstadoSistema() {
  if (this.systemStatusInterval) {
    window.clearInterval(this.systemStatusInterval);
    this.systemStatusInterval = null;
  }
},


async comprobarEstadoSistema() {
  /*
   * Guardamos el estado ANTES de hacer la consulta.
   */
  const estabaBloqueado =
    this.systemWasBlocked || this.store.systemBlocked;

  try {
    const estado = await this.store.checkSystemStatus();

    /*
     * -------------------------------------------------------
     * EL DEMONIO ESTÁ TRABAJANDO
     * -------------------------------------------------------
     */
    if (estado.blocked) {
      this.systemWasBlocked = true;

      /*
       * Si estaba abierta la intro, la cerramos.
       * Durante procesamiento no debe mostrarse nada más.
       */
      if (this.mostrarIntroTemporada) {
        this.cerrarIntroTemporada();
      }

      return;
    }

    /*
     * -------------------------------------------------------
     * ACABA DE TERMINAR EL DEMONIO
     * -------------------------------------------------------
     *
     * Antes estaba bloqueado y ahora ya no.
     */
    if (
      estabaBloqueado
      && this.systemWasBlocked
      && !this.systemReloading
    ) {
      await this.finalizarBloqueoSistema();
    }
  } catch (error) {
    console.error(
      "Error controlando el estado del sistema:",
      error
    );
  }
},


async finalizarBloqueoSistema() {
  this.systemReloading = true;
  this.systemWasBlocked = false;

  try {
   
    await this.store.loadAll();

  } catch (error) {
    console.error(
      "Error actualizando el juego después del procesamiento:",
      error
    );

  } finally {
    this.systemReloading = false;
  }


  if (
    this.activeLigaId
    && !this.store.systemBlocked
    && !this.modoPruebaIntro
  ) {
    await this.comprobarIntroTemporada(
      this.activeLigaId
    );
  }
},
    anteriorIntroSlide() {
  this.limpiarTimerIntro();

  if (this.introFrameActual <= 0) {
    return;
  }

  this.introFrameActual -= 1;
  this.programarSiguienteSlide();
},
   async comprobarIntroTemporada(ligaId) {
  const normalizedLigaId = Number(ligaId);

  if (
    !Number.isInteger(normalizedLigaId)
    || normalizedLigaId
      !== Number(this.ligaIntroPermitidaId)
  ) {
    return;
  }

  if (this.modoPruebaIntro) {
    this.abrirIntroTemporada();
    return;
  }

  if (
    this.ligasIntroComprobadas.includes(
      normalizedLigaId
    )
  ) {
    return;
  }

  this.ligasIntroComprobadas.push(normalizedLigaId);

  const requestVersion = ++this.introRequestVersion;

  try {
    const response = await axios.post(
      `/api/ligas/${normalizedLigaId}/intro/consume`
    );

    if (
      requestVersion !== this.introRequestVersion
      || Number(this.activeLigaId) !== normalizedLigaId
    ) {
      return;
    }

    const result = response.data?.data ?? response.data;

    if (result?.mostrar !== true) {
      return;
    }

    this.ligaIntroActual = normalizedLigaId;
    this.abrirIntroTemporada();
  } catch (error) {
    this.ligasIntroComprobadas =
      this.ligasIntroComprobadas.filter(
        id => Number(id) !== normalizedLigaId
      );

    console.error(
      "Error comprobando la intro de temporada:",
      error
    );
  }
},

    abrirIntroTemporada() {
      this.limpiarTimerIntro();
      this.introFrameActual = 0;
      this.mostrarIntroTemporada = true;

      this.$nextTick(() => {
        this.programarSiguienteSlide();
      });
    },

    programarSiguienteSlide() {
      this.limpiarTimerIntro();

      const slide = this.introSlideActual;

      if (!slide || !this.mostrarIntroTemporada) {
        return;
      }

      this.introTimer = window.setTimeout(() => {
        if (this.introFrameActual >= this.introSlides.length - 1) {
          
          this.introTimer = null;
          return;
        }

        this.introFrameActual += 1;
        this.programarSiguienteSlide();
      }, slide.duration || 3000);
    },

    siguienteIntroSlide() {
  this.limpiarTimerIntro();

  if (this.introFrameActual >= this.introSlides.length - 1) {
    this.cerrarIntroTemporada();
    return;
  }

  this.introFrameActual += 1;
  this.programarSiguienteSlide();
},

   

    cerrarIntroTemporada() {
      this.limpiarTimerIntro();
      this.mostrarIntroTemporada = false;
      this.introFrameActual = 0;
    },

    limpiarTimerIntro() {
      if (this.introTimer) {
        window.clearTimeout(this.introTimer);
        this.introTimer = null;
      }
    },

    logout() {
      this.introRequestVersion += 1;
      this.limpiarTimerIntro();
      this.store.logout();
      this.$router.push("/login");
    },
    sendIncidence() {
    const destinatario = "feedbackelectroliga@simulart-team.atlassian.net";
    const asunto = "Electroliga";

    const cuerpo = `
    
      Incidencia:
      -	Fecha  
      -	Sección (Mercado / Plantilla / Minijuegos / etc).                 
      -	¿Qué estabas intentando hacer? 
      -	¿Qué ocurrió? 
      -	¿Qué esperabas que ocurriera? 
      -	Dispositivo (PC/móvil/Tablet)
      -	Navegador (Chrome, Firefox, etc) 
      -	¿Se repite?  Sí/No       
      -	Captura (Opcional) 


      Un saludo.`;

          const asuntoCodificado = encodeURIComponent(asunto);
          const cuerpoCodificado = encodeURIComponent(cuerpo);

          const mailtoLink =
            `mailto:${destinatario}?subject=${asuntoCodificado}&body=${cuerpoCodificado}`;

          window.location.href = mailtoLink;
        },

    getAvatarStorageKey() {
      const username = this.store.authUser?.username || "jugador";
      return `electroliga_avatar_${username}`;
    },

    loadSelectedAvatar() {
      const savedAvatarId = Number(
        localStorage.getItem(this.getAvatarStorageKey())
      );

      const avatar = this.avatarOptions.find(
        option => option.id === savedAvatarId
      );

      if (avatar) {
        this.selectedAvatarId = avatar.id;
        this.selectedAvatar = avatar.src;
      }
    },

    selectAvatar(avatar) {
      this.selectedAvatarId = avatar.id;
      this.selectedAvatar = avatar.src;

      localStorage.setItem(
        this.getAvatarStorageKey(),
        avatar.id
      );
    },
  },
};
</script>

<style scoped>
.avatar-button {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.user-avatar-selector {
  background: rgba(49, 99, 95, 0.12);
  border: 2px solid rgba(49, 99, 95, 0.35);
  overflow: hidden;
  transition: all 0.2s ease;
}

.avatar-button:hover .user-avatar-selector {
  background: rgba(49, 99, 95, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(49, 99, 95, 0.25);
}

.avatar-menu-card {
  min-width: 260px;
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.98),
      rgba(237, 250, 246, 0.96)
    ) !important;
}

.avatar-menu-title {
  font-family: "Orbitron", sans-serif !important;
  color: #31635f;
  font-size: 13px;
  font-weight: 700;
}

.avatar-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.avatar-option {
  width: 44px;
  height: 44px;
  border-radius: 999px;
  border: 2px solid rgba(49, 99, 95, 0.18);
  background: white;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
}

.avatar-option:hover {
  border-color: #31635f;
  transform: scale(1.08);
  box-shadow: 0 4px 12px rgba(49, 99, 95, 0.25);
}

.avatar-option-active {
  border-color: #31635f;
  box-shadow:
    0 0 0 3px rgba(49, 99, 95, 0.18),
    0 4px 12px rgba(49, 99, 95, 0.28);
}

.avatar-option-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.home-container {
  max-width: 1200px;
}

.home-header-card {
  position: relative;
  overflow: hidden;
  border-radius: 24px !important;
  background:
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.96),
      rgba(230, 248, 240, 0.94)
    ) !important;
  border: 1px solid rgba(49, 99, 95, 0.18);
  box-shadow: 0 16px 45px rgba(49, 99, 95, 0.13);
}

.home-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.home-header-left,
.home-header-right {
  display: flex;
  align-items: center;
  min-width: 0;
}

.home-header-left {
  flex: 0 1 auto;
}

.home-header-right {
  flex: 0 0 auto;
  margin-left: auto;
}

/* Columna con Electroliga arriba y Simulart debajo */
.logos-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 130px;
  min-width: 180px;
}

.electroliga-logo {
  width: 150px;
  max-width: 150px;
  max-height: 80px;
  flex: none;
}

.simulart-logo-under {
  width: 100px;
  max-width: 100px;
  max-height: 26px;
  flex: none;
}

.home-title-wrapper {
  min-width: 0;
}

.orbitron-title {
  color: #31635f;
  font-family: "Orbitron", sans-serif !important;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-icon {
  font-size: 34px;
  color: #31635f;
}

.user-avatar-selector {
  width: 80px !important;
  height: 80px !important;
}

.game-main {
  position: relative;
  min-height: 100vh;
  background-image: url("~@/assets/fondo1.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Tablet / iPad */
@media (max-width: 960px) {
.home-header-right {
  gap: 2px;
}
  .home-container {
    max-width: 100%;
  }

  .home-header-card {
    padding: 8px !important;
  }

  .home-header {
    gap: 4px;
  }

  .logos-column {
    flex: 0 0 54px;
    min-width: 54px;
    gap: 3px;
    margin-right: 6px !important;
  }

  .electroliga-logo {
    width: 50px !important;
    max-width: 50px !important;
    max-height: 28px !important;
  }

  .simulart-logo-under {
    width: 44px !important;
    max-width: 44px !important;
    max-height: 16px !important;
  }

  .orbitron-title {
    font-size: 12px;
    line-height: 1;
    max-width: 95px;
  }

  /* Ocultamos avatar en tablet/móvil */
  .avatar-button {
    display: none !important;
  }

  .user-icon {
    display: none !important;
  }

  .user-chip {
    display: inline-flex !important;
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 9px !important;
    height: 20px !important;
    padding: 0 6px !important;
    margin-right: 4px !important;
  }

  .logout-btn {
    font-size: 9px !important;
    min-width: 36px !important;
    height: 22px !important;
    padding: 0 4px !important;
  }
}

/* Móvil */
@media (max-width: 600px) {
  .home-container {
    padding-left: 8px;
    padding-right: 8px;
  }

  .home-header-card {
    padding: 7px !important;
  }

  .logos-column {
    flex: 0 0 48px;
    min-width: 48px;
    gap: 2px;
  }

  .electroliga-logo {
    width: 46px !important;
    max-width: 46px !important;
    max-height: 26px !important;
  }

  .simulart-logo-under {
    width: 40px !important;
    max-width: 40px !important;
    max-height: 14px !important;
  }

  .orbitron-title {
    font-size: 11px;
    max-width: 82px;
  }

  .avatar-button {
    display: none !important;
  }

  .user-chip {
    display: inline-flex !important;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 8px !important;
    height: 20px !important;
    padding: 0 6px !important;
    margin-right: 4px !important;
  }

  .logout-btn {
    min-width: 34px !important;
    font-size: 8px !important;
  }

  .avatar-menu-card {
    min-width: 230px;
  }

  .avatar-grid {
    gap: 8px;
  }

  .avatar-option {
    width: 38px;
    height: 38px;
  }
}

/* Móvil muy estrecho */
@media (max-width: 380px) {
  .logos-column {
    flex: 0 0 42px;
    min-width: 42px;
  }

  .electroliga-logo {
    width: 40px !important;
    max-width: 40px !important;
    max-height: 23px !important;
  }

  .simulart-logo-under {
    width: 36px !important;
    max-width: 36px !important;
    max-height: 12px !important;
  }

  .orbitron-title {
    font-size: 10px;
    max-width: 70px;
  }

  .avatar-button {
    display: none !important;
  }

  .user-chip {
    display: inline-flex !important;
    max-width: 86px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 8px !important;
    height: 19px !important;
    padding: 0 5px !important;
    margin-right: 3px !important;
  }

  .logout-btn {
    min-width: 32px !important;
  }
}



.page-enter-enter-active,
.page-enter-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.page-enter-enter,
.page-enter-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

/* ============================================================
   INTRO DE NUEVA TEMPORADA
   ============================================================ */

::v-deep .intro-temporada-dialog {
  box-shadow: none !important;
}

.intro-temporada-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff !important;
  border: 2px solid rgba(88, 163, 158, 0.4);
  box-shadow: 0 22px 65px rgba(49, 99, 95, 0.25);
}

.intro-temporada-body {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-height: 0;
  background: #f5f7f6;
}

.intro-temporada-image {
  display: block;
  width: 100%;
  max-width: 100%;
  max-height: 78vh;
  object-fit: contain;
  background: #f5f7f6;
}

.intro-temporada-footer {
  flex: 0 0 auto;
  padding: 12px 14px 16px;
  background: #ffffff;
  border-top: 1px solid rgba(49, 99, 95, 0.12);
}

.intro-progress {
  display: flex;
  justify-content: center;
  gap: 8px;
  min-height: 8px;
  margin-bottom: 12px;
}

.intro-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: rgba(49, 99, 95, 0.22);
  transition:
    width 0.25s ease,
    background 0.25s ease;
}

.intro-dot-active {
  width: 24px;
  background: #58a39e;
}

.intro-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.intro-navigation {
  display: flex;
  align-items: center;
  gap: 6px;
}

.intro-skip-btn,
.intro-back-btn,
.intro-next-btn {
  font-family: "Orbitron", sans-serif !important;
  text-transform: none !important;
}

.intro-skip-btn,
.intro-back-btn {
  color: #31635f !important;
}

.intro-next-btn {
  min-width: 126px;
  height: 42px !important;
  background: #31635f !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 600;
}

.intro-next-btn:hover {
  background: #254e4a !important;
}

.intro-test-btn {
  position: fixed !important;
  right: 20px;
  bottom: 20px;
  z-index: 50;
  background: #d2a11e !important;
  color: #ffffff !important;
  font-family: "Orbitron", sans-serif !important;
  font-size: 11px !important;
  text-transform: none !important;
}

.intro-fade-enter-active,
.intro-fade-leave-active {
  transition:
    opacity 0.42s ease,
    transform 0.42s ease;
}

.intro-fade-enter {
  opacity: 0;
  transform: scale(1.015);
}

.intro-fade-leave-to {
  opacity: 0;
  transform: scale(0.99);
}

@media (max-width: 600px) {
  .intro-temporada-card {
    height: 100vh;
    height: 100dvh;
    border: none;
    border-radius: 0 !important;
  }

  .intro-temporada-body {
    flex: 1 1 auto;
    min-height: 0;
  }

  .intro-temporada-image {
    width: 100%;
    height: 100%;
    max-height: none;
    object-fit: contain;
  }

  .intro-temporada-footer {
    padding:
      10px
      max(12px, env(safe-area-inset-right))
      max(12px, env(safe-area-inset-bottom))
      max(12px, env(safe-area-inset-left));
  }

  .intro-progress {
    margin-bottom: 9px;
  }

  .intro-skip-btn {
    min-width: 62px !important;
    padding: 0 7px !important;
    font-size: 10px !important;
  }

  .intro-next-btn {
    min-width: 102px;
    height: 38px !important;
    padding: 0 13px !important;
    font-size: 10px !important;
  }

  .intro-back-btn {
    width: 36px !important;
    height: 36px !important;
  }

  .intro-test-btn {
    right: 10px;
    bottom: 10px;
    font-size: 9px !important;
  }
}
.intro-navigation {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.intro-back-btn {
  color: #31635f !important;
  font-family: "Orbitron", sans-serif !important;
  font-size: 12px !important;
  text-transform: none !important;
}

.intro-btn-icon {
  margin-right: 5px;
  font-size: 18px;
}

.intro-btn-icon-right {
  margin-right: 0;
  margin-left: 5px;
}

@media (max-width: 600px) {
  .intro-actions {
    gap: 6px;
  }

  .intro-navigation {
    gap: 4px;
  }

  .intro-back-btn,
  .intro-next-btn,
  .intro-skip-btn {
    min-width: 0 !important;
    padding: 0 9px !important;
    font-size: 10px !important;
  }

  .intro-btn-icon {
    font-size: 16px;
  }
}
/* ============================================================
   BLOQUEO GLOBAL - PROCESAMIENTO DEL DEMONIO
   ============================================================ */

.system-processing-overlay {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 999999 !important;
}

.system-processing-content {
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  min-height: 100dvh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 30px;
  text-align: center;

  background:
    radial-gradient(
      circle at center,
      rgba(255, 255, 255, 1) 0%,
      rgba(239, 249, 246, 1) 65%,
      rgba(226, 243, 239, 1) 100%
    );

  pointer-events: all;
  user-select: none;
}

.system-processing-logos {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  margin-bottom: 38px;
}

.system-electroliga-logo {
  width: 290px;
}

.system-simulart-logo {
  width: 130px;
}

.system-processing-spinner {
  margin-bottom: 34px;
}

.system-processing-title {
  max-width: 650px;

  font-family: "Orbitron", sans-serif !important;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.35;

  color: #31635f;
}

.system-processing-message {
  margin-top: 16px;

  font-family: "Orbitron", sans-serif !important;
  font-size: 14px;
  font-weight: 500;

  color: rgba(49, 99, 95, 0.72);
}

.system-processing-process {
  margin-top: 24px;
  padding: 7px 14px;

  border-radius: 999px;
  border: 1px solid rgba(88, 163, 158, 0.28);

  background: rgba(88, 163, 158, 0.08);

  font-family: "Orbitron", sans-serif !important;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  color: #58a39e;
}


/* Móvil */
@media (max-width: 600px) {
  .system-processing-content {
    padding:
      24px
      max(20px, env(safe-area-inset-right))
      max(24px, env(safe-area-inset-bottom))
      max(20px, env(safe-area-inset-left));
  }

  .system-processing-logos {
    margin-bottom: 30px;
  }

  .system-electroliga-logo {
    width: 230px;
    max-width: 80vw;
  }

  .system-simulart-logo {
    width: 105px;
  }

  .system-processing-title {
    max-width: 90vw;
    font-size: 19px;
  }

  .system-processing-message {
    font-size: 12px;
  }

  .system-processing-process {
    font-size: 9px;
  }
}
.header-action-icons {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 8px;
}

.header-icon-btn {
  width: 34px;
  height: 34px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 50%;
  background: transparent;

  color: #31635f;
  cursor: pointer;

  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    color 0.2s ease;
}

.header-icon-btn:hover {
  background: rgba(49, 99, 95, 0.1);
  transform: scale(1.08);
}

.header-icon-btn .material-symbols-outlined {
  font-size: 23px;
}

.delete-account-icon-btn:hover {
  color: #d32f2f;
  background: rgba(211, 47, 47, 0.08);
}

@media (max-width: 960px) {
  .header-action-icons {
    gap: 2px;
    margin-right: 4px;
  }

  .header-icon-btn {
    width: 28px;
    height: 28px;
  }

  .header-icon-btn .material-symbols-outlined {
    font-size: 18px;
  }
}

</style>
<style>
.swal2-confirm.liga-creada-confirmar {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  min-width: 160px !important;
  height: 48px !important;
  padding: 0 24px !important;

  border: none !important;
  border-radius: 8px !important;

  background-color: #31635f !important;
  color: #ffffff !important;

  font-family: "Orbitron", sans-serif !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  text-transform: none !important;

  cursor: pointer !important;

  box-shadow:
    0 6px 16px rgba(49, 99, 95, 0.25) !important;

  transition:
    background-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease !important;
}

.swal2-confirm.liga-creada-confirmar:hover {
  background-color: #244c49 !important;
  color: #ffffff !important;
  transform: translateY(-1px);

  box-shadow:
    0 8px 20px rgba(49, 99, 95, 0.34) !important;
}

.swal2-confirm.liga-creada-confirmar:focus {
  color: #ffffff !important;
  outline: none !important;

  box-shadow:
    0 0 0 3px rgba(49, 99, 95, 0.2),
    0 6px 16px rgba(49, 99, 95, 0.25) !important;
}

.swal2-confirm.liga-creada-confirmar:active {
  color: #ffffff !important;
  transform: translateY(0);
}
.swal2-cancel.clausulazo-swal-cancel {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  min-width: 160px !important;
  height: 44px !important;
  padding: 0 24px !important;

  border: none !important;
  border-radius: 999px !important;

  background: #4b5563 !important;
  color: #ffffff !important;

  font-family: "Orbitron", sans-serif !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  text-transform: uppercase !important;

  cursor: pointer !important;
  transition: background 0.2s ease, transform 0.2s ease !important;
}

.swal2-cancel.clausulazo-swal-cancel:hover {
  background: #374151 !important;
  transform: translateY(-1px);
}
</style>